/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class GroupSettingsRequest {
    'lockedProfile'?: boolean;
    'showNumberOfHorses'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "lockedProfile",
            "baseName": "lockedProfile",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "showNumberOfHorses",
            "baseName": "showNumberOfHorses",
            "type": "boolean",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return GroupSettingsRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

